<template>
  <div class="my-2">
    <v-toolbar flat color="white">
      <h3 class="title grey--text">Available Network Operators:</h3>
    </v-toolbar>
    <v-data-table :items="networkOperators" :headers="headers" :key="key" style="cursor: pointer">
      <template v-slot:items="props">
        <td class="text-xs-center" @click="routerLink(props.item)">
            <v-avatar size="100px">
          <v-img contain  :src="props.item.organisation.logo"/>
            </v-avatar>
        </td>
        <td class="text-xs-center" @click="routerLink(props.item)">{{props.item.organisation.name}}</td>
        <td class="text-xs-center" @click="routerLink(props.item)" >
          <span v-if="props.item.globalUnitsTotal>0">{{props.item.globalUnitsTotal}}</span>
          <span v-else>{{props.item.virtualNetworksTotal +props.item.directUnitsTotal}}</span>
          
          </td>
        
      </template>
    </v-data-table>
  </div>
</template>
<script>
import Api from "../services/Api";
export default {
  data() {
    return {
      networkOperators: [],
      key: 0,
      headers: [
        {
          text: "Logo",
          align: "center",
          sortable: false,
        },
        {
          text: "Name",
          align: "center",
          value: "networkProvider.name",
        },
        {
          text: "Units Passed",
          align: "center",
        },
      ],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getNetworkOperators();
    },
    routerLink(item){
        this.$router.push({
        path:
          "/networkOperators/" +
          item.organisationId
      });
    },
    getNetworkOperators() {
      Api()
        .get("/networkOperators")
        .then((response) => {
          this.networkOperators = response.data;
          this.key+=1
          console.log(response.data);
        });
    },
  },
};
</script>